import * as React from 'react';
import { colors } from '@styleseat/brand';

type CircleQuestionIconProps = {
  width?: number,
  height?: number,
  strokeWidth?: number,
  color?: string
} & React.SVGProps<SVGSVGElement>;

export const CircleQuestionIcon = ({
  width,
  height,
  color,
  strokeWidth,
  ...restProps
}: CircleQuestionIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 15 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...restProps}
  >
    <path
      d="M5.58337 5.24576C5.58354 4.46061 6.21974 3.80059 7.06186 3.71194C7.90398 3.62329 8.68382 4.13423 8.87414 4.89933C9.06447 5.66443 8.60467 6.44002 7.8056 6.70174C7.47249 6.81084 7.24986 7.10268 7.25004 7.42999V7.94774"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.62496 9.62057C6.62496 9.94034 6.90478 10.1996 7.24996 10.1996C7.59514 10.1996 7.87496 9.94034 7.87496 9.62057C7.87496 9.3008 7.59514 9.04157 7.24996 9.04157C6.90478 9.04157 6.62496 9.3008 6.62496 9.62057Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.25 12.5799C10.7018 12.5799 13.5 9.98762 13.5 6.78993C13.5 3.59224 10.7018 1 7.25 1C3.79822 1 1 3.59224 1 6.78993C1 9.98762 3.79822 12.5799 7.25 12.5799Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>

);

CircleQuestionIcon.defaultProps = {
  width: 15,
  height: 14,
  color: colors.blackInBlack,
  strokeWidth: 1.5,
};

export default CircleQuestionIcon;
